import React, { useState, useEffect } from "react";

import CalendarForm from "./CalendarForm";
import CalendarDetailModal from "./CalendarDetailModal";
import { getEmployeeFollowUpEventById } from "../../api/EmployeeFollowUpEventApi";
import {
  getCalendarEmployeeFollowUpEventList,
  getCalendarYearEmployeeFollowUpEventList,
  getCalendarDoneEmployeeFollowUpEventList,
  updateCalendarEmployeeFollowUpEvent,
} from "../../api/CalendarEmployeeFollowUpEventApi";
import moment from "moment";
import { GetUserByDepartmentId } from "../../api/UserApi";
import {
  appTitle,
  FollowUpEventTypeColor,
  Departement,
} from "../common/GeneralConfigurations";
import { dateFormat } from "../common/GeneralConfigurations";

import { Form } from "antd";

import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { getFollowUpEventList } from "../../api/FollowUpEventApi";

const ManageCalendarPage = () => {
  const [selectedDate, setSelectedDate] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalInputText, setModalInputText] = useState("");
  const [selectedEventType, setSelectedEventType] = useState("");
  const [datePickerValue, setDatePickerValue] = useState(
    moment(moment(), dateFormat)
  );
  const [entryId, setEntryId] = useState(-1);
  const [employeeFollowUpEvents, setEmployeeFollowUpEvents] = useState([]);
  const [employeeFollowUpEvent, setEmployeeFollowUpEvent] = useState([]);
  const [initValues, setInitValues] = useState({
    id: null,
    //hashId: null,
    employeeId: null,
    followUpEventId: null,
    date: undefined, //undefined
    feedBack: "",
    note: "",
    doneById: null,
    companyLevel: null,
    clientLevel: null,
    projectLevel: null,
    createdBy: null,
    createdAt: "",
    updatedBy: null,
    updatedAt: "",
    employeeName: "",
    eventType: "",
    done: "",
    doneByName: "",
    authenticatedId: '00000000-0000-0000-0000-000000000000',
  });
  const [eventTypeColor, setEventTypeColor] = useState("");
  const [followUpEventType, setFollowUpEventType] = useState("");
  const [eventType, setEventType] = useState("");
  const [employeeId, setEmployeeId] = useState(0);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [form] = Form.useForm();
  const [panelYear, setPanelYear] = useState(moment().year());
  const [panelMonth, setPanelMonth] = useState(moment().month());
  const [panelMode, setPanelMode] = useState("");
  const [eventsList, setEventsList] = useState([]);

  const [done, setDone] = useState("");

  useEffect(() => {
    document.title = `${appTitle} - Calendar`;
  }, []);

  useEffect(async () => {
    await getFollowUpEventList(1, 20, "", "", "", "False").then((res) => {
      if (res.status === 200) {
        res.data.result.forEach((elem) => {
          let event = FollowUpEventTypeColor.find((x) => x.id === elem.id);
          // event.name = elem.name;
        });
        setEventsList(res.data.result);
      }
    });
  }, []);

  useEffect(async () => {
    await getCalendarEmployeeFollowUpEventsByMonth();
    await getUserData();
    form.resetFields();
  }, [initValues]);

  useEffect(async () => {
    if (panelMode === "month") {
      await getCalendarEmployeeFollowUpEventsByMonth();
    }
  }, [panelMode, panelMonth, panelYear]);

  useEffect(async () => {
    if (panelMode === "year") {
      await getCalendarEmployeeFollowUpEventsByYear();
    }
  }, [panelMode, panelYear]);

  useEffect(async () => {
    if (done != null || done == null) {
      await getCalendarEmployeeFollowUpEventsByDone();
    }
  }, [done]);

  const getCalendarEmployeeFollowUpEventsByMonth = async () => {
    let res = await getCalendarEmployeeFollowUpEventList(
      eventType,
      done,
      panelMonth + 1,
      panelYear
    );

    if (res.status === 200) {
      setEmployeeFollowUpEvents(res.data.result);
      setLoading(false);
    } else {
      setEmployeeFollowUpEvents([]);
    }
  };

  const getCalendarEmployeeFollowUpEventsByYear = async () => {
    let res = await getCalendarYearEmployeeFollowUpEventList(
      eventType,
      done,
      panelYear
    );

    if (res.status === 200) {
      setEmployeeFollowUpEvents([]);
      setEmployeeFollowUpEvents(res.data.result);
    }
  };

  const getCalendarEmployeeFollowUpEventsByDone = async () => {
    let res = await getCalendarDoneEmployeeFollowUpEventList(
      eventType,
      done,
      panelMonth + 1,
      panelYear,
      panelMode
    );

    if (res.status === 200) {
      setEmployeeFollowUpEvents([]);
      setEmployeeFollowUpEvents(res.data.result);
    }
  };

  const getEmployeeFollowUpEvent = async (id) => {
    await getEmployeeFollowUpEventById(id).then((res) => {
      if (res.status === 200) {
        setEmployeeFollowUpEvent(res.data.result);
        let {
          id,
          employeeId,
          followUpEventId,
          date,
          feedBack,
          note,
          doneById,
          companyLevel,
          clientLevel,
          projectLevel,
          createdBy,
          createdAt,
          updatedBy,
          updatedAt,
          employeeName,
          eventType,
          done,
          doneByName,
          authenticatedId,
        } = res.data;

        date =
          date == null
            ? undefined
            : moment(JSON.stringify(date).substring(1, 11), dateFormat);

        setEmployeeId(id);
        setInitValues({
          id,
          employeeId,
          followUpEventId,
          date,
          feedBack,
          note,
          doneById: doneById,
          companyLevel,
          clientLevel,
          projectLevel,
          createdBy,
          createdAt,
          updatedBy,
          updatedAt,
          employeeName,
          eventType,
          done,
          doneByName,
          authenticatedId,
        });
      } else {
        setEmployeeFollowUpEvent([]);
      }
    });
  };

  const getUserData = async () => {
    let HRList = [];
    let ManagerList = [];
    await GetUserByDepartmentId(Departement.HumanResources).then((res) => {
      if (res.status === 200) {
        HRList = res.data.result;
      }
    });
    await GetUserByDepartmentId(Departement.Manager).then((res) => {
      if (res.status === 200) {
        ManagerList = res.data.result;
      }
    });

    setUsers(HRList.concat(ManagerList));
  };

  const onPanelChange = async (value, mode) => {
    if (mode == "year") {
      setPanelYear(moment(value).year());
      setPanelMode("year");
    }

    if (mode == "month") {
      setPanelYear(moment(value).year());
      setPanelMonth(moment(value).month());
      setPanelMode("month");
    }
  };

  const handleSelectEvent = (e) => {
    let defaultDate = "";
    setSelectedDate(e._d.toDateString());
    defaultDate = e.format(dateFormat);
    setDatePickerValue(moment(defaultDate, dateFormat));
  };

  const clearFields = () => {
    setModalInputText("");
    setSelectedEventType("");
    setDone("");
    setSelectedDate("");
    setEntryId(-1);
  };

  const handleModalCancel = async () => {
    //clearFields();
    setIsModalVisible(false);
    await getCalendarEmployeeFollowUpEventsByMonth();
    await getCalendarEmployeeFollowUpEventsByYear();
    await getCalendarEmployeeFollowUpEventsByDone();
  };

  const handleModalOk = async (values) => {
    await updateEmployeeFollowUp(values);
  };

  const handleOnChangeTextArea = (e) => {
    setModalInputText(e.target.value);
  };

  const handleFollowUpEventClick = async (index, id, eventColor) => {
    setEmployeeId(id);
    await getEmployeeFollowUpEvent(id);
    setEventTypeColor(eventColor);
    form.setFieldsValue(initValues);
    openEventDetailModal(index);
  };

  const openEventDetailModal = async (index) => {
    let e = employeeFollowUpEvents[index];
    getUserData();

    let eventTypeSelected = e.eventType.replace(/\s/g, "");
    setSelectedEventType(eventTypeSelected);
    if (e.date != null) {
      setDatePickerValue(
        moment(`${e.date.year}/${e.date.month}/${e.date.day}`)
      );
    } else {
      setDatePickerValue(
        moment(
          `${e.referenceDate.year}/${e.referenceDate.month}/${e.referenceDate.day}`
        )
      );
    }
    setEntryId(index);

    setIsModalVisible(true);
  };

  const updateEmployeeFollowUp = async (values) => {
    setSubmitLoading(true);
    values.id = employeeId;
    values.employeeId = initValues.employeeId;
    values.followUpEventId = initValues.followUpEventId;
    values.createdBy = initValues.createdBy;
    values.createdAt = initValues.createdAt;
    values.updatedAt = initValues.updatedAt;
    values.updatedBy = initValues.updatedBy;
    values.authenticatedId = initValues.authenticatedId;

    const res = await updateCalendarEmployeeFollowUpEvent(values);
    setSubmitLoading(false);

    if (res.data.errors === null) {
      await getCalendarEmployeeFollowUpEventsByMonth();
      AdnMessageSuccess();
      handleModalCancel();
    } else {
      AdnMessageError();
    }
  };

  const eventDateExists = (event, { day, month, year }) => {
    let complete_date = event.referenceDate;
    let event_year = -1;
    let event_month = -1;
    let event_day = -1;

    if (complete_date != null) {
      event_year = parseInt(complete_date.substr(0, 4));
      event_month = parseInt(complete_date.substr(5, 2)) - 1;
      event_day = parseInt(complete_date.substr(8, 2));
    }

    return event_day === day && event_month === month && event_year === year;
  };

  const monthHaveEvents = (event, { month }) => {
    let complete_date = event.referenceDate;
    let event_month = -1;

    if (complete_date != null) {
      event_month = parseInt(complete_date.substr(5, 2)) - 1;
    }

    return event_month === month;
  };

  const onDatePickerChange = (date, dateString) => {
    setDatePickerValue(date);
  };

  const handleEventTypeChange = (eventType) => {
    eventType != null
      ? FollowUpEventTypeColor.map((item) => {
          if (item.id == eventType) {
            setFollowUpEventType(item.name);
          }
        })
      : setFollowUpEventType("");
  };

  const meetingStatusOptions = [
    { id: true, name: "Done" },
    { id: false, name: "Not Done" },
  ];

  const handleDone = async (value) => {
    setDone(value);
  };

  const disabledEmployeeFollowUpEventDate = (currentDate) => {
    if (
      moment().year() < currentDate.year() ||
      moment().year() - currentDate.year() > 1
    )
      return true;

    if (moment().year() - currentDate.year() <= 0) {
      if (moment().month() < currentDate.month()) return true;

      if (moment().month() == currentDate.month()) {
        if (moment().date() < currentDate.date()) return true;
      }
    }
    return false;
  };

  return (
    <>
      <CalendarDetailModal
        title={"Event"}
        isModalVisible={isModalVisible}
        handleModalCancel={handleModalCancel}
        handleModalOk={handleModalOk}
        datePickerDefaultDate={selectedDate}
        onDatePickerChange={onDatePickerChange}
        datePickerValue={datePickerValue}
        datePickerFormat={dateFormat}
        textAreaValue={modalInputText}
        textAreaOnChange={handleOnChangeTextArea}
        form={form}
        initValues={initValues}
        eventTypeColor={eventTypeColor}
        employeeId={employeeId}
        users={users}
        submitLoading={submitLoading}
        disabledEmployeeFollowUpEventDate={disabledEmployeeFollowUpEventDate}
      />

      <CalendarForm
        eventDateExists={eventDateExists}
        handleSelectEvent={handleSelectEvent}
        handleFollowUpEventClick={handleFollowUpEventClick}
        onPanelChange={onPanelChange}
        employeeFollowUpEvents={employeeFollowUpEvents}
        handleEventTypeChange={handleEventTypeChange}
        loading={loading}
        monthHaveEvents={monthHaveEvents}
        followUpEventType={followUpEventType}
        users={users}
        meetingStatusOptions={meetingStatusOptions}
        meetingStatusChange={handleDone}
      />
    </>
  );
};

export default ManageCalendarPage;
